import Btn from "../ui/Btn.jsx";
import Display from "../ui/Display.jsx";
import Eyebrow from "../ui/Eyebrow.jsx";

export default function SwapOverlay({ swapSrc, groups, people, onSwap, onCancel }) {
  const sp = people.find(p => p.id === swapSrc.personId);
  const sg = groups.find(g => g.id === swapSrc.groupId);
  return (
    <div onClick={onCancel} style={{
      position: "fixed", inset: 0, zIndex: 1000,
      background: "rgba(34,28,20,0.4)",
      display: "flex", alignItems: "center", justifyContent: "center",
      backdropFilter: "blur(4px)",
    }}>
      <div onClick={(e) => e.stopPropagation()} style={{
        background: "var(--paper-0)", borderRadius: 14, padding: 28,
        maxWidth: 560, width: "92%", maxHeight: "82vh", overflow: "auto",
        border: "1px solid var(--line)", boxShadow: "0 24px 64px rgba(34,28,20,0.25)",
        color: "var(--ink)",
      }}>
        <Eyebrow style={{ marginBottom: 8 }}>Swap</Eyebrow>
        <Display size={22} style={{ marginBottom: 4 }}>
          Move {sp?.Name}
        </Display>
        <div style={{ fontSize: 13, color: "var(--ink-2)", marginBottom: 20 }}>
          Currently at <em>{sg?.name}</em>. Click someone in another group to exchange places.
        </div>
        {groups.filter(g => g.id !== swapSrc.groupId && g.people.length > 0).map(g => (
          <div key={g.id} style={{ marginBottom: 16 }}>
            <div style={{
              fontSize: 11, color: "var(--ink-3)",
              marginBottom: 7, textTransform: "uppercase",
              letterSpacing: 1.4, fontWeight: 600,
            }}>{g.name}</div>
            <div style={{ display: "flex", flexWrap: "wrap", gap: 5 }}>
              {g.people.map(pid => {
                const p = people.find(x => x.id === pid);
                if (!p) return null;
                return (
                  <div
                    key={pid}
                    onClick={() => onSwap(pid, g.id)}
                    style={{
                      padding: "5px 12px",
                      borderRadius: 999,
                      cursor: "pointer",
                      background: "var(--paper-1)",
                      border: "1px solid var(--line-2)",
                      fontSize: 12.5,
                      color: "var(--ink)",
                      transition: "all 0.12s",
                    }}
                    onMouseEnter={(e) => { e.currentTarget.style.background = "var(--ink)"; e.currentTarget.style.color = "var(--paper-0)"; }}
                    onMouseLeave={(e) => { e.currentTarget.style.background = "var(--paper-1)"; e.currentTarget.style.color = "var(--ink)"; }}
                  >{p.Name}</div>
                );
              })}
            </div>
          </div>
        ))}
        {groups.filter(g => g.id !== swapSrc.groupId && g.people.length > 0).length === 0 && (
          <div style={{ fontSize: 13, color: "var(--ink-3)", fontStyle: "italic", padding: "8px 0 16px" }}>
            No other groups have anyone to swap with.
          </div>
        )}
        <div style={{ marginTop: 18, display: "flex", justifyContent: "flex-end" }}>
          <Btn variant="quiet" onClick={onCancel}>Cancel</Btn>
        </div>
      </div>
    </div>
  );
}
